export default __webpack_public_path__ + "static/media/Gobold Hollow Bold.fdf526fd.otf";